export enum NavigationSteps {
    Vehicle = "vehicle",
    GraphicSearch = "graphicSearch",
}
